module.exports = __webpack_public_path__ + "img/love.4e23c5c2.jpg";